/**
 * Message Area - Displays messages and input
 */

import React, { useState } from 'react';
import { Empty } from 'antd';
import { MessageList } from './MessageList';
import { MessageInput } from './MessageInput';
import { ChatHeader } from './ChatHeader';
import { NewsFeedBanner } from './NewsFeedBanner';
import { ChannelNewsModal } from './ChannelNewsModal';
import './MessageArea.css';

interface MessageAreaProps {
  channelId: string | null;
  showChannelInfo?: boolean;
  onToggleChannelInfo?: () => void;
  onOpenThread?: (messageId: string) => void;
  onBackToList?: () => void;
  showBackButton?: boolean;
}

export const MessageArea: React.FC<MessageAreaProps> = ({ 
  channelId, 
  showChannelInfo = false,
  onToggleChannelInfo,
  onOpenThread,
  onBackToList,
  showBackButton = false,
}) => {
  const [replyingToMessageId, setReplyingToMessageId] = useState<string | null>(null);
  const [newsModalVisible, setNewsModalVisible] = useState(false);

  const handleReplyToMessage = (messageId: string) => {
    setReplyingToMessageId(messageId);
  };

  const handleCancelReply = () => {
    setReplyingToMessageId(null);
  };

  if (!channelId) {
    return (
      <div className="message-area-empty">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontWeight: 600, marginBottom: 4 }}>Select a conversation</div>
              <div style={{ fontSize: 13, color: '#8c8c8c' }}>Choose from your chats on the left</div>
            </div>
          }
        />
      </div>
    );
  }

  return (
    <div className={`message-area ${showChannelInfo ? 'has-right-sidebar' : ''}`}>
      <ChatHeader
        channelId={channelId}
        onBackToList={showBackButton ? onBackToList : undefined}
        showBackButton={showBackButton}
        newsModalVisible={newsModalVisible}
        onNewsModalOpen={() => setNewsModalVisible(true)}
        onNewsModalClose={() => setNewsModalVisible(false)}
      />
      <NewsFeedBanner
        channelId={channelId}
        onViewAll={() => setNewsModalVisible(true)}
      />
      <div className="message-list-container" ref={(el) => {
        if (el) {
          (window as any).chatMessageListContainer = el;
        }
      }}>
        <MessageList 
          channelId={channelId} 
          onReplyToMessage={handleReplyToMessage}
          onOpenThread={onOpenThread}
        />
      </div>
      <div className="message-input-container">
        <MessageInput 
          channelId={channelId} 
          replyTo={replyingToMessageId}
          onCancelReply={handleCancelReply}
        />
      </div>
      <ChannelNewsModal
        channelId={channelId}
        open={newsModalVisible}
        onClose={() => setNewsModalVisible(false)}
      />
    </div>
  );
};

